import * as React from 'react';
import Card from './Card';
import '../css/tooltip.sass';

interface TooltipProps {
  toolTip: React.ReactNode;
  theme?: 'day' | 'night';
  onBlur?: Function;
}

interface TooltipState {
  toolTipCardOpen: boolean;
}

export default function Tooltip(props: TooltipProps) {
  const { theme = 'day' } = props;
  const tooltip: any = React.useRef();
  const [state, setState] = React.useState<TooltipState>({
    toolTipCardOpen: false
  });
  const handleEsc = (e: any) => {
    if (e.keyCode === 27 || e.key === 'Escape') {
      setState({ ...state, toolTipCardOpen: false });
      if (props.onBlur !== undefined) {
        props.onBlur();
      }
    }
  };
  const handleClickOutside = (e: any) => {
    if (tooltip.current && !tooltip.current.contains(e.target)) {
      setState({ ...state, toolTipCardOpen: false });
    }
    if (props.onBlur !== undefined) {
      props.onBlur();
    }
  };

  React.useEffect(() => {
    document.addEventListener('keydown', handleEsc);
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('keydown', handleEsc);
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [tooltip]);

  return (
    <div className="tooltip tooltip-text">
      {props.toolTip && (
        <div className="tooltip-info">
          <div
            id="tooltip"
            role="button"
            aria-label={state.toolTipCardOpen ? `Hide toolTip` : `Show toolTip`}
            className={`icon ${theme}`}
            onMouseDown={e => {
              e.preventDefault();
            }}
            onKeyDown={e => {
              if (e.keyCode === 13 || e.keyCode === 32) {
                setState({ ...state, toolTipCardOpen: !state.toolTipCardOpen });
              }
            }}
            onClick={() => {
              setState({ ...state, toolTipCardOpen: !state.toolTipCardOpen });
            }}
            tabIndex={0}
          >
            {' '}
          </div>
        </div>
      )}
      {props.toolTip && state.toolTipCardOpen && (
        <div
          id="tooltip-info-card"
          className={`tooltip-info-card ${theme === 'day' ? 'night' : 'day'}`}
          ref={tooltip}
        >
          <Card theme={theme === 'day' ? 'night' : 'day'}>
            <p>{props.toolTip}</p>
          </Card>
        </div>
      )}
    </div>
  );
}
